export const MINUTE = 60_000;
/** Sorts, drops empty ranges and merges overlapping or touching intervals. */
export function normalize(intervals) {
    const sorted = intervals.filter((i) => i.end > i.start).sort((a, b) => a.start - b.start);
    const out = [];
    for (const i of sorted) {
        const last = out[out.length - 1];
        if (last && i.start <= last.end)
            last.end = Math.max(last.end, i.end);
        else
            out.push({ start: i.start, end: i.end });
    }
    return out;
}
/** Parts of `a` that are also in `b`. Both inputs may be unsorted. */
export function intersect(a, b) {
    const x = normalize(a);
    const y = normalize(b);
    const out = [];
    let i = 0;
    let j = 0;
    while (i < x.length && j < y.length) {
        const p = x[i];
        const q = y[j];
        const start = Math.max(p.start, q.start);
        const end = Math.min(p.end, q.end);
        if (end > start)
            out.push({ start, end });
        if (p.end < q.end)
            i++;
        else
            j++;
    }
    return out;
}
/** Parts of `a` that are not covered by `b`. */
export function subtract(a, b) {
    const cuts = normalize(b);
    const out = [];
    for (const base of normalize(a)) {
        let cursor = base.start;
        for (const c of cuts) {
            if (c.end <= cursor)
                continue;
            if (c.start >= base.end)
                break;
            if (c.start > cursor)
                out.push({ start: cursor, end: c.start });
            cursor = Math.max(cursor, c.end);
            if (cursor >= base.end)
                break;
        }
        if (cursor < base.end)
            out.push({ start: cursor, end: base.end });
    }
    return out;
}
/** True when `inner` lies completely inside one of the (normalized) `free` intervals. */
export function fits(inner, free) {
    // Binary search for the last interval starting at or before inner.start.
    let lo = 0;
    let hi = free.length - 1;
    let candidate = -1;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        if (free[mid].start <= inner.start) {
            candidate = mid;
            lo = mid + 1;
        }
        else
            hi = mid - 1;
    }
    if (candidate < 0)
        return false;
    return free[candidate].end >= inner.end;
}
export function overlaps(a, b) {
    return a.start < b.end && b.start < a.end;
}
export function totalMinutes(intervals) {
    return normalize(intervals).reduce((sum, i) => sum + (i.end - i.start) / MINUTE, 0);
}
/**
 * Open gaps in someone's day: working time not taken by appointments or blocked time,
 * from `from` on (rounded up to the next `step` minutes), at least `minMinutes` long.
 */
export function openGaps(working, busy, options) {
    const step = (options.step ?? 5) * MINUTE;
    const from = options.from === undefined ? -Infinity : Math.ceil(options.from / step) * step;
    return subtract(working, busy)
        .map((g) => ({ start: Math.max(g.start, from), end: g.end }))
        .filter((g) => g.end - g.start >= options.minMinutes * MINUTE);
}
//# sourceMappingURL=intervals.js.map